import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'

import { getGetShipmentApiV1ShipmentsShipmentIdGetQueryOptions } from '#/shared/api/generated/shipment/theCargoShipment'

export interface ShipmentDetailTarget {
  shipmentId: string
  to: string
  params: Record<string, string>
}

/** Drop the `preview` key so navigating to the full page closes the sidebar. */
function withoutPreview(
  prev: Record<string, unknown>,
): Record<string, unknown> {
  const next = { ...prev }
  delete next['preview']
  return next
}

export function useOpenShipmentDetail() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return ({ shipmentId, to, params }: ShipmentDetailTarget) => {
    void queryClient.prefetchQuery(
      getGetShipmentApiV1ShipmentsShipmentIdGetQueryOptions(shipmentId),
    )
    return navigate({
      to: to as never,
      params: params as never,
      search: withoutPreview as never,
    })
  }
}
